module.exports = __webpack_public_path__ + "img/left15.dd88c4a.svg";